module.exports = __webpack_public_path__ + "img/HygieneServices.e612f817.jpg";